class HierarchySPARQLQuery {
    constructor(wikidataId) {
        // Extract Q-ID from full URL if needed
        this.wikidataId = wikidataId.includes('entity/')
            ? wikidataId.replace('http://www.wikidata.org/entity/', '')
            : wikidataId;
    }

    getComprehensiveHierarchyQuery() {
        return `
        SELECT DISTINCT ?item ?itemLabel ?instanceOf ?instanceOfLabel ?superclass ?superclassLabel ?depth WHERE {
            {
                # The target item itself
                BIND(wd:${this.wikidataId} AS ?item)
                BIND(0 AS ?depth)
                OPTIONAL { ?item wdt:P31 ?instanceOf . }
                OPTIONAL { ?item wdt:P279 ?superclass . }
            }
            UNION
            {
                # Direct instance types (level 1)
                wd:${this.wikidataId} wdt:P31 ?item .
                BIND(1 AS ?depth)
                OPTIONAL { ?item wdt:P31 ?instanceOf . }
                OPTIONAL { ?item wdt:P279 ?superclass . }
            }
            UNION
            {
                # Second level parents
                wd:${this.wikidataId} wdt:P31/wdt:P279 ?item .
                BIND(2 AS ?depth)
                OPTIONAL { ?item wdt:P31 ?instanceOf . }
                OPTIONAL { ?item wdt:P279 ?superclass . }
            }
            UNION
            {
                # Third level parents
                wd:${this.wikidataId} wdt:P31/wdt:P279/wdt:P279 ?item .
                BIND(3 AS ?depth)
                OPTIONAL { ?item wdt:P31 ?instanceOf . }
                OPTIONAL { ?item wdt:P279 ?superclass . }
            }
            UNION
            {
                # Fourth level parents
                wd:${this.wikidataId} wdt:P31/wdt:P279/wdt:P279/wdt:P279 ?item .
                BIND(4 AS ?depth)
                OPTIONAL { ?item wdt:P31 ?instanceOf . }
                OPTIONAL { ?item wdt:P279 ?superclass . }
            }
            UNION
            {
                # Fifth level parents
                wd:${this.wikidataId} wdt:P31/wdt:P279/wdt:P279/wdt:P279/wdt:P279 ?item .
                BIND(5 AS ?depth)
                OPTIONAL { ?item wdt:P31 ?instanceOf . }
                OPTIONAL { ?item wdt:P279 ?superclass . }
            }
            
            # Filter out very generic concepts that aren't useful
            FILTER(?item != wd:Q35120)  # Filter out "entity" 
            FILTER(?item != wd:Q4406616) # Filter out "Wikidata item"
            FILTER(?item != wd:Q488383)  # Filter out "object"
            
            SERVICE wikibase:label { 
                bd:serviceParam wikibase:language "en" 
            }
        }
        ORDER BY ?depth ?itemLabel
        LIMIT 100
        `;
    }
}

export default HierarchySPARQLQuery;